import React from 'react';
import { SelectInput, useQuery } from 'react-admin';

/**
 * Category picker shared by every supply screen.
 * Reads the list from the API and falls back to the two seeded categories
 * so the screen still works if the lookup call fails.
 */
const FALLBACK = [
    { id: 2, name: 'Calibration Supply' },
    { id: 1, name: 'Donation Softgoods' },
];

const SupplyCategoryInput = props => {
    const { data } = useQuery({
        type: 'getList',
        resource: 'supplycategories',
        payload: {
            filter: {},
            sort: { field: 'name', order: 'ASC' },
            pagination: { page: 1, perPage: 25 },
        },
    });

    const choices = data && data.length ? data : FALLBACK;

    return (
        <SelectInput
            source="category_id"
            label="Category"
            choices={choices}
            optionText="name"
            optionValue="id"
            {...props}
        />
    );
};

export default SupplyCategoryInput;
